module.exports = __webpack_public_path__ + "static/media/netskope-logo-white.af753a89.svg";